import * as React from 'react';
import GoogleMapReact from 'google-map-react';
import '../../../../../styles/PropertiesPage.css';
import { Property } from '../../../../../api/Property';
import { PropertyMarker } from './Marker';
import { useEffect } from 'react';
import { useGeocodedProperties, useGeocodedState, useMaps } from '../../../../../hooks/useMaps';
import { PropertyQuery, PropertyQueryType } from './PropertyQuery';
import { StateInformation } from '../../../../../api/LocationSearch';

export interface Props {
    selectedProperty?: Property;
    properties: Property[];
    states: StateInformation[];
    setSelectedProperty: (property: Property) => void;
    propertyQuery: PropertyQuery;
}

const UNITED_STATES = { lat: 36.2115201, lng: -113.7164387 };
const DEFAULT_ZOOM = 3;

const MAXIMUM_CITY_ZOOM = 12;
const MAXIMUM_PROPERTY_ZOOM = 17;

const fitPropertyBounds = (
    map: google.maps.Map,
    maps: any,
    geocodedProperties: Property[],
    queryType: PropertyQueryType
) => {
    const bounds: google.maps.LatLngBounds = new maps.LatLngBounds();
    geocodedProperties.forEach(place => {
        if (place.latitude && place.longitude) {
            bounds.extend(new maps.LatLng(place.latitude, place.longitude));
        }
    });
    map.fitBounds(bounds);

    let zoomLevel = map.getZoom();
    if (queryType === PropertyQueryType.Property && zoomLevel > MAXIMUM_PROPERTY_ZOOM) {
        map.setZoom(MAXIMUM_PROPERTY_ZOOM);
    }
    if (queryType === PropertyQueryType.City && zoomLevel > MAXIMUM_CITY_ZOOM) {
        map.setZoom(MAXIMUM_CITY_ZOOM);
    }
};

const MapView = (props: Props) => {
    const matchingState = props.states.find(
        s => s.stateInitials === props.propertyQuery.stateAbbreviation
    );

    if (matchingState === undefined) {
        return null;
    }

    const { mapRef, mapsRef, geocoder, handleApiLoaded } = useMaps();
    const geocodedProperties = useGeocodedProperties(geocoder, props.properties);
    const geocodedState = useGeocodedState(geocoder, matchingState);

    const fitBounds = (map: google.maps.Map, maps: any) => {
        if (
            geocodedProperties &&
            geocodedProperties.length > 0 &&
            props.propertyQuery.type !== PropertyQueryType.State
        ) {
            fitPropertyBounds(map, maps, geocodedProperties, props.propertyQuery.type);
            return;
        }

        if (geocodedState) {
            map.fitBounds(geocodedState);
            return;
        }

        map.setCenter(UNITED_STATES);
        map.setZoom(DEFAULT_ZOOM);
    };

    useEffect(() => {
        if (mapRef && mapsRef) {
            fitBounds(mapRef, mapsRef);
        }
    }, [geocodedProperties, geocodedState, mapRef]);

    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '' }}
            defaultCenter={UNITED_STATES}
            yesIWantToUseGoogleMapApiInternals={true}
            defaultZoom={DEFAULT_ZOOM}
            onGoogleApiLoaded={(maps: { map: google.maps.Map; maps: any }) =>
                handleApiLoaded(maps.map, maps.maps)
            }
            options={{ clickableIcons: false }}
        >
            {geocodedProperties &&
                geocodedProperties.map(p =>
                    p.latitude && p.longitude ? (
                        <PropertyMarker
                            key={p.slug}
                            lat={p.latitude}
                            lng={p.longitude}
                            setSelectedProperty={() => props.setSelectedProperty(p)}
                            propertySelected={
                                props.selectedProperty !== undefined &&
                                props.selectedProperty.slug === p.slug
                            }
                        />
                    ) : null
                )}
        </GoogleMapReact>
    );
};

export default MapView;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/MapView.tsx